import Vue from 'vue';
import Vuetify, {
  ClickOutside,
  VBtn,
  VIcon,
  VScrollXReverseTransition,
  VScrollXTransition,
  VSnackbar,
} from 'vuetify/lib';
import {Touch} from 'vuetify/lib/directives';
import VuetifyToast from 'vuetify-toast-snackbar-ng';
import es from 'vuetify/src/locale/es';
import en from 'vuetify/src/locale/en';
import {i18n} from '@/plugins/i18n';

Vue.use(Vuetify, {
    directives: {Touch, outside: ClickOutside},
    components: {
        VSnackbar,
        VBtn,
        VIcon,
        VScrollXTransition,
        VScrollXReverseTransition,
    },
});
Vue.use(VuetifyToast, {
    classes: [
        'body-2',
    ],
    y: 'top',
    x: 'center',
    queueable: true,
    showClose: true,
    closeIcon: 'close',
    timeout: 2000,
    multiLine: true,
});
export default new Vuetify(
  {
      icons: {
          iconfont: 'md',
      },
      lang: {
          locales: {es, en},
          current: i18n.locale,
      },
      theme: {
          options: {
              customProperties: true,
          },
          themes: {
              light: {
                primary: '#1f2937',
                secondary: '#363636',
                accent: '#efa81b',
                error: '#e83a3d',
                info: '#0a6bb8',
                success: '#408a40',
                warning: '#e8a600',
                background: '#f3f4f6',
                neuter: '#e4e5fd',
                white: '#FFFFFF',
                gray: '#6c757d',
                metal: '#ebebeb',
                credit: '#5f3580',
                cash: '#428544',
                darkError: '#B71C1C'
              },
          },
      },
    },
);
